import React from 'react'
import { cn } from '../../lib/utils'

export interface SlideProgressProps {
  current: number
  total: number
  className?: string
}

export const SlideProgress: React.FC<SlideProgressProps> = ({
  current,
  total,
  className,
}) => {
  const percentage = ((current + 1) / total) * 100

  return (
    <div
      className={cn(
        'fixed top-0 left-0 w-full h-1 bg-border z-50',
        className
      )}
    >
      <div
        className="h-full bg-primary dark:bg-primary-400 transition-all duration-300 ease-out"
        style={{ width: `${percentage}%` }}
      />
    </div>
  )
}

export interface SlideCounterProps {
  current: number
  total: number
  className?: string
}

export const SlideCounter: React.FC<SlideCounterProps> = ({
  current,
  total,
  className,
}) => {
  return (
    <div
      className={cn(
        'fixed bottom-4 right-4 px-4 py-2 bg-card/90 backdrop-blur rounded-lg shadow-lg text-sm font-medium text-foreground z-40',
        className
      )}
    >
      {current + 1} / {total}
    </div>
  )
}
